import React,{useState} from 'react'

export default function About() {
    const [text,setText]=useState("Enable Dark Mode")
    const [myStyle,setMyStyle]=useState(
        {
            color:"black",
            backgroundColor:"white"
        }
    )

   

    const darkMode=()=>{
        if(text==="Enable Dark Mode"){
            setText("Disable Dark Mode");
            setMyStyle(
                {
                    color:"white",
                    backgroundColor:"black",
                    border:"1px solid white"
                } 
            )
        }
        if(text==="Disable Dark Mode"){
            setText("Enable Dark Mode");
            setMyStyle(
                {
                    color:"black",
                    backgroundColor:"white"
                } 
            )
        }
       
    };
    
    return (
        <div className="container" style={myStyle}>
        <h1>About Me</h1>
            <div className="accordion" id="accordionPanelsStayOpenExample" style={myStyle}>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                        <button className="accordion-button" type="button" style={myStyle} data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                            My Name
                        </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show"  aria-labelledby="panelsStayOpen-headingOne">
                        <div className="accordion-body" style={myStyle}>
                            <strong>Suraj Sahani</strong> 
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" style={myStyle} data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                           About Me
                        </button>
                    </h2>
                    <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                        <div className="accordion-body" style={myStyle}>
                            <strong>I am a Full Stack Web Developer.</strong> 
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" style={myStyle} data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                           About Website
                        </button>
                    </h2>
                    <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                        <div className="accordion-body" style={myStyle}>
                            <strong>TextUtils is a utility which can be used to manipulate your text in the way you want.</strong>
                        </div>
                    </div>
                </div>
            </div>
            <button type="button" className="btn btn-dark btn-lg m-3" onClick={darkMode} >{text}</button>
        </div>
    )
}
